import { useState, useEffect } from 'react';
import { execSeatableSql } from './seatable.js';
import AllImg from './allimg.js';
import AllMarkdown from './allmarkdown.js';
import Typewriter from 'typewriter-effect';

function Hero(props) {
    const [data, setData] = useState(null);

    useEffect(() => {
      async function fetchData() {
        const sql = `SELECT * FROM CapabilitySections WHERE \`Capability\` = '${props.capability}' AND \`PageSection\` = 'Hero'`;
        setData(null);

        try {
          const rows = await execSeatableSql(sql);
          setData(rows && rows.results[0]);
        } catch (err) {
          // setError(err);
        }
      }
      fetchData();
    }, [props.capability]);

    return (<>
        <div className="hero-section d-flex flex-column flex-lg-row">
            {data && data["fnMediaLink"] ? (
            <div className="w-100 py-3 p-lg-5 d-flex flex-column flex-lg-row">
                <AllImg className="img-fluid" src={data && data["fnMediaLink"]} alt={props.capability} />
            </div>
            ) : ''}
            <div className="w-100 d-flex flex-column flex-grow-1 justify-content-evenly">
                <div className="p-lg-3 py-3 h-25 d-flex align-items-center" data-aos="fade-right" data-aos-delay="100">
                    <div className="pb-1 border-bottom border-white"><div className="section-title lato-black">{props.capability}</div></div>
                </div>
                <div className="p-lg-3 py-3 h-25 d-flex align-items-end" data-aos="fade-right" data-aos-delay="100">
                    <div className="section-title lato-black">{data && data["Section Title"]}</div>
                </div>
                <div className="p-lg-3 py-3 section-sub-title lato-light" data-aos="fade-up" data-aos-delay="100">
                    <AllMarkdown>{data && data["Section Sub Headline"]}</AllMarkdown>
                    {data && data.HeroScrollingText && (data.HeroScrollingText.length > 0) ? (
                    <div className="mt-3">
                        <Typewriter options={{
                            strings: data && data.HeroScrollingText.map(row => row.display_value), 
                            autoStart: true, 
                            loop: true, 
                            cursor: '_',
                            delay: '50',
                            wrapperClassName: "section-typing",
                            }} />
                    </div>
                    ) : ''}
                </div>
            </div>
        </div>
        <div className="mb-5 d-flex flex-grow-1 border-bottom border-secondary" style={{margin: "0 5vw 0 5vw"}}></div>
    </>)
}

export default Hero;